import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: false
};

const pre = 'dashboard-';

export default {
    path: '/dashboard',
    name: 'dashboard',
    redirect: {
        name: `${pre}console`
    },
    meta,
    component: BasicLayout,
    children: [
        // {
        //     path: 'nauticalChart',
        //     name: `${pre}nauticalChart`,
        //     meta: {
        //         ...meta,
        //         title : '$t:menu.homePage',
        //         desc : '主控台'
        //     },
        //     component: () => import('@/pages/dashboard/nauticalChart')
        // },
        {
            path: 'console',
            name: `${pre}console`,
            meta: {
                ...meta,
                title : '$t:menu.homePage',
                desc : '主控台'
            },
            component: () => import('@/pages/dashboard/console')
        },
        {
            path:  'user/userInfo/:id',
            name: 'userInfo',
            meta: {
                ...meta,
                title: '$t:menu.userInfo',
                desc : '个人信息'
            },
            component: () => import('@/pages/dashboard/user/userInfo')
        },
        {
            path:  'user/userInfoEdit/:id',
            name: 'userInfoEdit',
            meta: {
                ...meta,
                title: '$t:menu.userInfoEdit',
                desc : '编辑个人信息'
            },
            component: () => import('@/pages/dashboard/user/userInfoEdit')
        },
        {
            path:  'user/updatePassword/:id',
            name: 'updatePassword',
            meta: {
                ...meta,
                title: '$t:menu.updatePassword',
                desc : '修改密码'
            },
            component: () => import('@/pages/dashboard/user/updatePassword')
        },
        {
            path:  '/user/updatePassword/:id/:flg',
            name: 'updatePassword2',
            meta: {
                ...meta,
                title: '$t:menu.resPwd',
                desc : '重置密码'
            },
            component: () => import('@/pages/dashboard/user/updatePassword')
        },
        {
            path: 'monitor',
            name: `${pre}monitor`,
            meta: {
                ...meta,
                title: '$t:menu.monitor',
                desc : '监控页'
            },
            component: () => import('@/pages/dashboard/monitor')
        },
        {
            path: 'workplace',
            name: `${pre}workplace`,
            meta: {
                ...meta,
                title: '$t:menu.gongzuotai',
                desc : '工作台'
            },
            component: () => import('@/pages/dashboard/workplace')
        },{
            path: '/doc',
            name: `doc`,
            meta: {
                auth: false,
                cache:true,
                title : '$t:menu.doc',
                desc : '文档页'
            },
            component: () => import('@/pages/dashboard/ifame/doc.vue')
        }

    ]
};
